// extracted by mini-css-extract-plugin
export default {"container":"ReversePennydrop_container__i0nkP","main":"ReversePennydrop_main__Y0Xhl","body":"ReversePennydrop_body__wT+XN"};